import * as React from "react";
import Paper from "@mui/material/Paper";
import { ViewState, EditingState } from "@devexpress/dx-react-scheduler";
import {
  Scheduler,
  WeekView,
  MonthView,
  Appointments,
  ViewSwitcher,
  Toolbar,
  DragDropProvider,
  EditRecurrenceMenu,
} from "@devexpress/dx-react-scheduler-material-ui";
import { useState } from "react";
import moment from "moment";
import axios from "axios";
import LoaderPost from "../../../../Reuseable/LoaderPost";

const SuperstarScheduleListMonthly = () => {
  const [loading, setloading] = useState(true);
  const [schedule, setSchedule] = useState({});
  const currentDate = moment(new Date()).format("YYYY-MM-DD");
  let schedule_data = [];

  React.useEffect(() => {
    axios.get("/api/star/current_month_schedule_list").then((res) => {
      if (res.data.status === 200) {
        res.data.schedule.forEach(function (item) {
          schedule_data.push({
            title: item.title.toUpperCase(),
            startDate: new Date(
              Number(moment(item.startDate).format("YYYY")),
              Number(moment(item.startDate).format("MM") - 1),
              Number(moment(item.startDate).format("DD")),
              Number(moment(item.from, "HH:mm:ss").format("H")),
              Number(moment(item.from, "HH:mm:ss").format("m"))
            ),
            endDate: new Date(
              Number(moment(item.startDate).format("YYYY")),
              Number(moment(item.startDate).format("MM") - 1),
              Number(moment(item.startDate).format("DD")),
              Number(moment(item.to, "HH:mm:ss").format("H")),
              Number(moment(item.to, "HH:mm:ss").format("m"))
            ),
          });
        });
        setSchedule({ data: schedule_data });
        setloading(false);
      }
    });
  }, []);

  const commitChanges = ({ added, changed, deleted }) => {
    setSchedule((state) => {
      let { data } = state;
      if (added) {
        const startingAddedId =
          data.length > 0 ? data[data.length - 1].id + 1 : 0;
        data = [...data, { id: startingAddedId, ...added }];
      }
      if (changed) {
        data = data.map((appointment) =>
          changed[appointment.id]
            ? { ...appointment, ...changed[appointment.id] }
            : appointment
        );
      }
      if (deleted !== undefined) {
        data = data.filter((appointment) => appointment.id !== deleted);
      }
      return { data };
    });
  };

  const { data } = schedule;
  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          <Paper>
            <Scheduler data={data}>
              <ViewState defaultCurrentDate={currentDate} />
              <EditingState onCommitChanges={commitChanges} />
              <WeekView startDayHour={0} endDayHour={24} />
              <MonthView />
              <Appointments />

              <Toolbar />
              <ViewSwitcher />

              <EditRecurrenceMenu />

              <DragDropProvider />
            </Scheduler>
          </Paper>
        </>
      )}
    </>
  );
};
export default SuperstarScheduleListMonthly;
